import { ISVGSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import { IEquipment } from '@/pages/Equipment/equipment.types.ts'
import parameterIdToSourceIdMap from '@/pages/Parameters/parameters.map'

const liftWinchPowerSvgSettings = (equipmentId: IEquipment['id']): ISVGSettings => ({
  text: [],
  color: [
    {
      node_id: 'kmf_12_opened',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_34_opened',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_34_opened',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_56_opened-0',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_12_opened',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'lkmf_line_2',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isCarInMotion',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_relay',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isCarInMotion',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'lkmf_line_3',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isCarInMotion',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'arrow_kmf_a2',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isCarInMotion',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'lkmf_line_1',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'l160_line_1',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_relay-9',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },

    {
      node_id: 'l160_line_2',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_56_switch',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'l161_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'run_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDRunSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_5354_closed',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDRunSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'run_line_1',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDRunSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'arrow_53',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDRunSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'ready_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'brk_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['BRCxControlFlag'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'LKMC_line_1',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['LKMCCmd'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_relay',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['LKMCCmd'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'LKMC_line_2',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['LKMCCmd'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'arrow_kmc_a2',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['LKMCCmd'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'onkmc_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['ONKMCSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_2221_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['ONKMCSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_2221_closing_pin',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['ONKMCSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'onkmc_line_1',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['ONKMCSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'arrow_21',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['ONKMCSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'station_w_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_34_switch',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'path5279',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_w_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_R1R2_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_R1R2_closing_pin',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'dot_r3',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'dot_r2',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'dot_r1',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'r2_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'path5581-9',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_w_line_1',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'station_v_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_34_switch',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'drive_v_pin',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_v_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_v_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'station_u_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDReadySgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_w_line_2',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_R3R4_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_R3R4_closing_pin',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'path5581-9-8',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'r4_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'dot_r4',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'drive_w_pin',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'drive_u_pin',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF12Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_u_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF12Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_12_switch',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF12Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'path5027',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['BRCxControlFlag'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'path5029',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['BRCxControlFlag'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'dot_r4-8',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['BRCxControlFlag'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'brc1_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: 280,
      condition: '=',
      value: 1,
    },
    {
      node_id: 'brc2_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['BRC2Sgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'embrk_line',
      color: 'var(--text-link)',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['K7RelayState'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'brake2',
      color: 'var(--error-border)',
      device_id: equipmentId,
      parameter_id: 'computed:isCarInMotion',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'brake1-stroke-1',
      color: 'var(--error-border)',
      device_id: equipmentId,
      parameter_id: 'computed:isCarInMotion',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'brake1-stroke-2',
      color: 'var(--error-border)',
      device_id: equipmentId,
      parameter_id: 'computed:isCarInMotion',
      condition: '=',
      value: 1,
    },
  ],
  title: '',
  image_id: 'cd8f57ae-4c4d-44cb-a9af-81230e3951c0',
  movements: [
    {
      type: 'movements',
      parameter_id: 'computed:isCarInMotion',
      value: 1,
      device_id: equipmentId,
      node_id: 'brake2',
      condition: '=',
      cycle: false,
      direction: 'top',
      distance: 7,
      duration: 0.3,
      hide_self: false,
      rotate_one_way: false,
    },
    {
      type: 'movements',
      parameter_id: 'computed:isCarInMotion',
      value: 1,
      device_id: equipmentId,
      node_id: 'brake1',
      condition: '=',
      cycle: false,
      direction: 'bottom',
      distance: 7,
      duration: 0.3,
      hide_self: false,
      rotate_one_way: false,
    },
  ],
  rotations: [],
  visibility: [
    {
      node_id: 'kmf_5354_opened',
      action: 'hide',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDRunSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_welded_alert_text',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:isKMFContactorWelded',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_break_alert_text',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:isKMFContactorBreak',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kms_break_alert_text',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:isKMСContactorBreak',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_body_fill',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:isKMFContactorWelded',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_body_fill',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:isKMFContactorBreak',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_body_fill',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:isKMСContactorBreak',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_5354_closed',
      action: 'show',
      device_id: equipmentId,
      parameter_id: parameterIdToSourceIdMap['MDRunSgl'],
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_12_closed',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF12Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_12_opened',
      action: 'hide',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF12Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_34_opened',
      action: 'hide',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmf_34_closed',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:isKMF34Closed',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_34_closed-9',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_56_closed-5',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_34_opened',
      action: 'hide',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_56_opened-0',
      action: 'hide',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_12_opened',
      action: 'hide',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
    {
      node_id: 'kmc_12_closed',
      action: 'show',
      device_id: equipmentId,
      parameter_id: 'computed:MDReadySglANDONKMCSgl',
      condition: '=',
      value: 1,
    },
  ],
})

export default liftWinchPowerSvgSettings
